import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-939dab22"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "board-table"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  key: 3
};
const _hoisted_6 = {
  key: 4
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
import IncomePermissionNotice from '@/components/IncomePermissionNotice.vue';
import dayjs from 'dayjs';
import { Empty } from 'ant-design-vue';
import { columns } from '../data';
import { usePagination } from '@/hooks/usePagination';
import { useRouter } from 'vue-router';
import { reportEvent } from '@/common';
import { queryBillList } from '@/api/billBoardApi';
import { useIncomePermissionQuery } from '@/hooks/useIncomePermissionQuery';
export default /*#__PURE__*/_defineComponent({
  __name: 'BoardTable',
  setup(__props, {
    expose
  }) {
    const dataSource = ref([]);
    const {
      loading: tableLoading,
      permissionMessage,
      emptyDescription,
      begin
    } = useIncomePermissionQuery();
    const searchForm = ref({});
    const {
      pageTotal,
      pageIndex,
      pageSize,
      currentPageSizeChange
    } = usePagination(() => {
      initTableData(searchForm.value);
    });
    const router = useRouter();
    const scrollY = ref(300);
    const initTableData = async obj => {
      const startTime = new Date().getTime();
      const permissionRequest = begin(obj.dbtIdList || []);
      dataSource.value = [];
      pageTotal.value = 0;
      try {
        var _Object$keys;
        tableLoading.value = true;
        if ((_Object$keys = Object.keys(obj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          searchForm.value = obj;
        }
        const {
          startDateTime,
          endDateTime,
          datePeriod,
          timeZone,
          dbtIdList,
          payChnl
        } = obj;
        const params = {
          startDateTime: dayjs(startDateTime).format('YYYY-MM-DD'),
          endDateTime: dayjs(endDateTime).format('YYYY-MM-DD'),
          datePeriod,
          timeZone,
          dbtIdList,
          payChnl,
          pageSize: pageSize.value,
          pageNum: pageIndex.value
        };
        const result = await queryBillList(params);
        const {
          code,
          data
        } = result;
        if (!permissionRequest.isCurrent()) return;
        if (code == '0') {
          var _data$total;
          permissionRequest.accept(result);
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: `对账看板搜索`,
              app_name: '',
              return_duration: new Date().getTime() - startTime,
              query_status: 'succeed'
            }
          });
          dataSource.value = (data === null || data === void 0 ? void 0 : data.list) || [];
          pageTotal.value = (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0;
        } else {
          permissionRequest.fail();
        }
        tableLoading.value = false;
      } catch (e) {
        if (!permissionRequest.isCurrent()) return;
        permissionRequest.fail();
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: `对账看板搜索`,
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'failed'
          }
        });
      } finally {
        permissionRequest.finish();
      }
    };
    // 动态更新 scrollY，比如根据窗口高度调整
    const updateScrollY = () => {
      const height = window.innerHeight; // 假设预留一些空间
      scrollY.value = height - 54 - 32 - 90 - 48 - 48 - 48 - 110 + 48;
    };
    const handleJump = (record, type) => {
      router.push({
        name: 'reconciliationDetail',
        query: {
          type,
          aggregateId: record.aggregateId
        }
      });
    };
    onMounted(() => {
      updateScrollY();
      window.addEventListener('resize', updateScrollY);
    });
    expose({
      initTableData
    });
    return (_ctx, _cache) => {
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(permissionMessage) ? (_openBlock(), _createBlock(IncomePermissionNotice, {
        key: 0,
        message: _unref(permissionMessage)
      }, null, 8, ["message"])) : _createCommentVNode("", true), _createVNode(_component_a_table, {
        columns: _unref(columns),
        "data-source": dataSource.value,
        loading: _unref(tableLoading),
        scroll: {
          y: scrollY.value
        },
        bordered: "",
        pagination: false
      }, {
        emptyText: _withCtx(() => [_createVNode(_component_a_empty, {
          image: _unref(Empty).PRESENTED_IMAGE_SIMPLE,
          description: _unref(emptyDescription)
        }, null, 8, ["image", "description"])]),
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'diffRateRevenue' ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "jump-link",
          onClick: $event => handleJump(record, 'bill')
        }, _toDisplayString(`${record.diffRevenue}(${record === null || record === void 0 ? void 0 : record.diffRateRevenue})`), 9, _hoisted_2)) : _createCommentVNode("", true), column.dataIndex === 'diffRateOrderAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`${record.diffOrderAmount}(${record === null || record === void 0 ? void 0 : record.diffRateOrderAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRateAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${record.diffAmount}(${record === null || record === void 0 ? void 0 : record.diffRateAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRateRefundOrderAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${record.diffRefundOrderAmount}(${record === null || record === void 0 ? void 0 : record.diffRateRefundOrderAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRateRefundAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${record.diffRefundAmount}(${record === null || record === void 0 ? void 0 : record.diffRateRefundAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'payOrderAmount' ? (_openBlock(), _createElementBlock("span", {
          key: 5,
          class: "jump-link",
          onClick: $event => handleJump(record, 'payOrder')
        }, _toDisplayString(record === null || record === void 0 ? void 0 : record.payOrderAmount), 9, _hoisted_7)) : _createCommentVNode("", true), column.dataIndex === 'thirdOrderAmount' ? (_openBlock(), _createElementBlock("span", {
          key: 6,
          class: "jump-link",
          onClick: $event => handleJump(record, 'payIos')
        }, _toDisplayString(record === null || record === void 0 ? void 0 : record.thirdOrderAmount), 9, _hoisted_8)) : _createCommentVNode("", true), column.dataIndex === 'payRefundOrderAmount' ? (_openBlock(), _createElementBlock("span", {
          key: 7,
          class: "jump-link",
          onClick: $event => handleJump(record, 'refundOrder')
        }, _toDisplayString(record === null || record === void 0 ? void 0 : record.payRefundOrderAmount), 9, _hoisted_9)) : _createCommentVNode("", true), column.dataIndex === 'thirdRefundOrderAmount' ? (_openBlock(), _createElementBlock("span", {
          key: 8,
          class: "jump-link",
          onClick: $event => handleJump(record, 'refundIos')
        }, _toDisplayString(record === null || record === void 0 ? void 0 : record.thirdRefundOrderAmount), 9, _hoisted_10)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll"]), _createVNode(_component_a_pagination, {
        class: "board-table-pagination",
        total: _unref(pageTotal),
        "show-total": total => `共 ${total} 条`,
        current: _unref(pageIndex),
        "onUpdate:current": _cache[0] || (_cache[0] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        "onUpdate:page-size": _cache[1] || (_cache[1] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        onChange: _unref(currentPageSizeChange)
      }, null, 8, ["total", "show-total", "current", "page-size", "onChange"])]);
    };
  }
});